import windowsXpImageUrl from "@/images/windows-xp.webp";

import { showToast } from "./toasts";

export const DEMO_IMAGE_UPLOAD_REPLACEMENT_URL = windowsXpImageUrl;

export const showDemoImageUploadReplacementToast = () => {
  showToast({
    type: "warn",
    title: "Image replaced for demo mode",
    message:
      "Normally, your image would've been uploaded. However, we don't allow uploads in the demo site, so instead you get this. Enjoy the meadow.",
  });
};
